import React from 'react';
import { RatingLayout } from '../rating.layout';
import { PagePath } from '../../../../navigation/navigation.enums';

export function PeerSkillRatingPage(): JSX.Element {
  return <RatingLayout path={PagePath.analysisPeerSkillsAssessmentRating } title="Review team member" type="peer" />;
}